import { ValidationError } from '@/models/ValidationError';

export interface ISubmissionState {
  errors: Record<string, ValidationError[]>;
}

export const SubmissionState: ISubmissionState = {
  errors: {}
};
